import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import StepForm from '../../../../../../features/components/Forms/StepForm'
import NameStep from '../Steps/NameStep'
import FacebookPageStep from '../Steps/FacebookPageStep'
import StatusStep from '../Steps/StatusStep'
import StoriesStep from '../Steps/StoriesStep'
import UrlTagsStep from '../Steps/UrlTagsStep'
import WarningStep from '../Steps/WarningStep'

import { useCreateFacebookAd } from '../hooks/useCreateFacebookAd'
import getShowUrlTagsStep from '../helpers/getShowUrlTagsStep'

import { accessibleSocialPagesSelector } from '../../../../../../modules/selectors/socialAccounts'

import { FORMAT_STORY } from '../../../fields'

const StoryAdRoute = ({
  FormRouteSelector,
  eventSourceStep,
  isInternalAdCreation,
  selectedApplicationId,
  selectedPixelPassedFromOutside,
  allowSendPixel,
  ...formProps
}) => {
  const facebookPages = useSelector(accessibleSocialPagesSelector)

  const { isAdSetEndDateInThePast, showAsStory, purifiedFormik, isDomainValidating } = useCreateFacebookAd({
    isInternalAdCreation,
    selectedApplicationId,
    selectedPixelPassedFromOutside,
    allowSendPixel,
    formatOption: FORMAT_STORY
  })

  const { values } = purifiedFormik
  const showUrlTagsStep = getShowUrlTagsStep(values)

  const steps = useMemo(
    () => [
      {
        component: <WarningStep />,
        show: isAdSetEndDateInThePast
      },
      {
        component: FormRouteSelector,
        show: !showAsStory
      },
      {
        component: <NameStep />,
        show: true
      },
      {
        component: <FacebookPageStep />,
        show: facebookPages.length !== 1
      },
      {
        component: <StoriesStep />,
        show: true
      },
      eventSourceStep,
      {
        component: <UrlTagsStep selectedApplicationId={selectedApplicationId} />,
        show: showUrlTagsStep
      },
      {
        component: <StatusStep />,
        show: true
      }
    ],
    [
      FormRouteSelector,
      eventSourceStep,
      isAdSetEndDateInThePast,
      showAsStory,
      facebookPages,
      showUrlTagsStep,
      selectedApplicationId
    ]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} isSubmitDataLoading={isDomainValidating} />
}

export default StoryAdRoute
